import React from 'react';
import clsx from 'clsx';

import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ReportIcon from '@material-ui/icons/Report';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';

import { makeStyles } from '@material-ui/core/styles';
import { green, amber, orange, blue, grey, red } from '@material-ui/core/colors';

export const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[4],
    },
  },
  cardContent: {
    flexGrow: 1,
  },
  avatar: {
    backgroundColor: blue[500],
    marginBottom: theme.spacing(2),
  },
  avatarSuccess: {
    backgroundColor: green[500],
  },
  avatarWarning: {
    backgroundColor: amber[500],
  },
  avatarError: {
    backgroundColor: red[500],
  },
  avatarPending: {
    backgroundColor: orange[500],
  },
  avatarDisabled: {
    backgroundColor: grey[500],
  },
  avatarNeutral: {
    backgroundColor: grey[600],
  },
  statusIcon: {
    marginLeft: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
}));

const DashboardCard = ({ title, description, icon, status, action }) => {
  const classes = useStyles();

  const getStatusConfig = (status) => {
    const configs = {
      success: {
        avatarClass: classes.avatarSuccess,
        tooltip: "Concluído",
        Icon: CheckCircleIcon,
        color: green[700]
      },
      warning: {
        avatarClass: classes.avatarWarning,
        tooltip: "Pendente",
        Icon: WarningIcon,
        color: amber[700]
      },
      error: {
        avatarClass: classes.avatarError,
        tooltip: "Ação Necessária",
        Icon: ReportIcon,
        color: red[700]
      },
      pending: {
        avatarClass: classes.avatarPending,
        tooltip: "Aguardando Validação",
        Icon: AssignmentLateIcon,
        color: orange[700]
      },
      disabled: {
        avatarClass: classes.avatarDisabled,
        tooltip: "",
        Icon: null,
        color: null
      }
    };

    return configs[status] || {
      avatarClass: classes.avatarNeutral,
      tooltip: "",
      Icon: null,
      color: null
    };
  };

  const config = getStatusConfig(status);

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <div className={classes.header}>
            <Avatar className={clsx(classes.avatar, config.avatarClass)}>
              {icon}
            </Avatar>
            <div className={classes.statusIcon}>
              {config.Icon && (
                <Tooltip title={config.tooltip} TransitionComponent={Zoom}>
                  <config.Icon style={{ color: config.color }} />
                </Tooltip>
              )}
            </div>
          </div>
          <Typography variant="h6" component="h2" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          {action}
        </CardActions>
      </Card>
    </Grid>
  );
};

export default DashboardCard;
